import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  UxModal,
  UxModalHeader,
  UxModalBody,
  UxModalFooter
} from '@lwt-helix/core';
import Select from 'react-select';

const OfficeSelectModal = props => {
  // state lives on this component until user clicks "done", at which ponit it propogates upwards
  const [newOffices, setNewOffices] = useState([]);
  // ensure that we have the latest version to start with when editing
  const { currentOffices } = props;
  useEffect(() => setNewOffices([...(currentOffices || [])]), [currentOffices]);
  const reset = () => {
    setNewOffices([...(currentOffices || [])]);
    props.close();
  };
  const submit = () => {
    props.setCurrentOffices(newOffices);
    props.close();
  };

  const values = newOffices.map(office => {
    for (const option of props.options) {
      if (option.value === office) {
        return option;
      }
    }
  });

  return (
    <UxModal title="Select Offices" isOpen={props.open} toggle={reset}>
      <UxModalHeader toggle={reset} closeAriaLabel="close">
        Select Offices
      </UxModalHeader>
      <UxModalBody>
        <Select
          isMulti
          backspaceRemovesValue
          options={props.options || []}
          value={values}
          onChange={data =>
            setNewOffices((data || []).map(datum => { return datum.value; }))
          }
        />
      </UxModalBody>
      <UxModalFooter
        primaryLabel="Done"
        primaryAction={submit}
        cancelAction={reset}
      />
    </UxModal>
  );
};

const mapStateToProps = (state, ownProps) => {
  if (
    ownProps.offices !== state.roster.offices &&
    state.roster.offices != null
  ) {
    return {
      // tech debt: offices props is only used to skip the mapping when office data hasn't changed
      // Should actually use a memoized mapping function instead, but...
      offices: state.roster.offices,
      options: state.roster.offices.map(office => ({
        value: office.id,
        label: office.shortName
      }))
    };
  } else {
    return {};
  }
};

export default connect(mapStateToProps)(OfficeSelectModal);
